<template>
  <svg 
    class="icon" 
    aria-hidden="true" 
    :style="iconStyles">
    <use :href="symbolId" :fill="color" />
  </svg>
</template>

<script lang="ts">
  import { defineComponent, computed } from 'vue'
  import { obj2strStyle } from '@utils'
  
  export default defineComponent({
    name: 'SvgIcon',
    props: {
      prefix: {
        type: String,
        default: 'icon',
      },
      name: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        default: '#333',
      },
      size: { type: Number }
    },

    setup(props) {
      const symbolId = computed(() => `#${props.prefix}-${props.name}`)
      const iconStyles = computed(() => {
        let styles: any = {}

        if (props.size != undefined) {
          styles.width = props.size + 'px'
          styles.height = props.size + 'px'
        }

        return obj2strStyle(styles)
      })

      return { symbolId, iconStyles }
    },
  })
</script>

<style lang="scss" scoped>
  .icon {
    width: 1em;
    height: 1em;
    overflow: hidden;
    vertical-align: middle;
    fill: currentColor;
  }

  // .vite-icon {
  //   font-style: normal;
  //   font-size: inherit;
  //   // font-family: 'luuk-icon', sans-serif !important;
  //   -webkit-font-smoothing: antialiased;
  //   -webkit-text-stroke-width: .2px;
  //   -moz-osx-font-smoothing: grayscale;
  // }
</style>
